export default "__VITE_ASSET__C8fiYx37__"